/**
 * "Open in detailed view" from a side panel: the record's own screen. From the simple view it switches the UI mode
 * first, the way the rail's "Detailed view" does (`SimpleRailFooter`), so the screen opens in the detailed shell.
 */
import { useNavigate } from 'react-router-dom';
import { useUiMode } from '../../hooks/useUiMode.js';

export function useOpenInDetailedView(): (href: string) => void {
  const navigate = useNavigate();
  const { uiMode, setUiMode } = useUiMode();
  return (href: string) => {
    if (uiMode === 'simple') setUiMode('detailed');
    navigate(href);
  };
}
